import React, { FunctionComponent, useEffect, useState } from 'react';
import withContext from '../../ContextAPI/Context_HOC';
import FundNoteProxy from './FundNoteProxy';
import CircularProgress from '@material-ui/core/CircularProgress';
import { OCSURL } from '../../constants';

const FundNumbersTable: FunctionComponent<{
  context: { fundNoteProxy: FundNoteProxy };
}> = ({ context: { fundNoteProxy } }) => {
  const [fundNote, setFundNote] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fundNoteSubscription = fundNoteProxy.getFundNoteList().subscribe({
      next: (x) => {
        if (x.length === 0) {
          setError('No numbers found.');
          setFundNote([]);
          setLoading(false);
          return;
        }
        setFundNote(x[0]);
        setError(null);
        setLoading(false);
      },
      error: () => {
        setError('Failed to load numbers. Please try again later.');
        setFundNote([]);
        setLoading(false);
      },
    });
    return () => {
      fundNoteSubscription.unsubscribe();
    };
  }, [fundNoteProxy]);

  if (error) {
    return (
      <div className="fund-video-loading-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="fund-video-loading-container">
        <CircularProgress data-cy="loading-animation-container" className="loading-animation" size={80} />
      </div>
    );
  }

  return (
    <div className="boxStyle">
      <h3>National Fund Update</h3>
      <p>
        <strong>
          For the year ending April 30, 2026. Contributions as of{' '}
          {fundNote.contributionsAsOf.value
            ? new Date(fundNote.contributionsAsOf.value).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })
            : ''}
          :
        </strong>
        <br />
        <br />
        <strong>National Fund:</strong>
        <br />
        <strong className="red-text">{fundNote.nationalFund.value}</strong>
        <br />
        <br />
        <strong>Regional Fund:</strong>
        <br />
        <strong className="red-text">{fundNote.regionalFund.value}</strong>
        <br />
        <br />
        <strong>Continental Fund:</strong>
        <br />
        <strong className="red-text">{fundNote.continentalFund.value}</strong>
        <br />
        <br />
        <strong>International Fund:</strong>
        <br />
        <strong className="red-text">{fundNote.internationalFund.value}</strong>
        <br />
        <br />
        <strong>Shrine of ‘Abdu’l-Bahá Fund</strong> (since inauguration of the Fund)
        <br />
        <strong className="red-text">{fundNote.shrineOfAbdulBahaFund.value}</strong>
      </p>
      <a className="home-button small-bottom-margin full-width center" href={OCSURL} target="_blank" rel="noopener noreferrer">
        Online Contribution System
      </a>
      <a
        className="home-button small-bottom-margin full-width center"
        href="https://www.bahaitreasurer.us/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Office of the Treasurer
      </a>
    </div>
  );
};

export default withContext(FundNumbersTable);
